import { useState } from 'react';
import { Link } from 'react-router-dom';
import PriceCard from '@/components/feature/PriceCard';
import { priceList } from '@/mocks/priceData';
import type { PriceItem } from '@/types';

const tabs: { key: 'all' | 'spot' | 'futures'; label: string }[] = [
  { key: 'all', label: '全部' },
  { key: 'spot', label: '现货' },
  { key: 'futures', label: '期货' },
];

export default function PriceOverview() {
  const [tab, setTab] = useState<'all' | 'spot' | 'futures'>('all');

  const list = (priceList as PriceItem[]).filter((item) => tab === 'all' || item.type === tab);
  const upCount = (priceList as PriceItem[]).filter((item) => item.change >= 0).length;
  const downCount = priceList.length - upCount;

  return (
    <section className="mx-auto max-w-portal px-4 py-12 md:px-6 md:py-14">
      <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-primary-700">Market Board</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">黄金行情快览</h2>
          <p className="mt-2 text-sm text-foreground-600">
            覆盖黄金现货、期货等主流品种 · 数据更新至 2026-10-12 15:30（演示数据）
          </p>
        </div>
        <div className="flex items-center gap-5">
          <div className="flex items-center gap-2 text-sm">
            <span className="flex items-center gap-1 text-accent-600">
              <i className="ri-arrow-up-line" aria-hidden="true"></i>上涨 {upCount}
            </span>
            <span className="flex items-center gap-1 text-secondary-500">
              <i className="ri-arrow-down-line" aria-hidden="true"></i>下跌 {downCount}
            </span>
          </div>
          <div className="flex rounded-full border border-background-300 p-1">
            {tabs.map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => setTab(item.key)}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  tab === item.key ? 'bg-primary-500 text-foreground-950' : 'text-foreground-600 hover:text-primary-700'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.slice(0, 6).map((item) => (
          <PriceCard key={item.id} item={item} />
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/category/gold-price"
          className="inline-flex items-center gap-1.5 rounded-md border border-primary-300 bg-primary-50 px-6 py-2.5 text-sm font-semibold text-primary-800 transition-colors hover:bg-primary-100 whitespace-nowrap"
        >
          查看全部黄金行情
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}